// extracted by mini-css-extract-plugin
export default {"dropdown":"index_dropdown__kSIP"};